import { environment } from '../../../environments/environment';
import { GamesName } from './games-name.enum';

/**
 * Substitui os parâmetros de path (ex.: "{idGame}") pelo valor informado,
 * já com encodeURIComponent aplicado. Centraliza a montagem de path params
 * para as rotas não fazerem replace manual e sem encoding em cada service.
 */
function buildPath(path: string, params: Record<string, string> = {}): string {
  return Object.entries(params).reduce(
    (resolvedPath, [key, value]) => resolvedPath.replaceAll(`{${key}}`, encodeURIComponent(value)),
    path,
  );
}

function buildUrl(path: string, params: Record<string, string> = {}): string {
  return `${environment.apiBaseUrl}${buildPath(path, params)}`;
}

/**
 * Rotas de sessão comuns a todo jogo: cada jogo tem tudo sob `/{slug}`, inclusive a
 * criação da sessão (`POST /{slug}/sessions`). Novos jogos (ex.: Overkill) reaproveitam
 * este padrão e só acrescentam as rotas próprias.
 */
function gameSessionRoutes(slug: GamesName) {
  const sessionsPath = `/${slug}/sessions`;
  const sessionPath = `${sessionsPath}/{idSession}`;
  return {
    sessions: (): string => buildUrl(sessionsPath),
    session: (idSession: string): string => buildUrl(sessionPath, { idSession }),
    sessionAction: (idSession: string, action: string): string =>
      buildUrl(`${sessionPath}/${action}`, { idSession }),
  };
}

const quemSouEuSessions = gameSessionRoutes(GamesName.QuemSouEu);

export const ApiRoutes = {
  games: {
    getAll: (): string => buildUrl('/games'),
    getThemes: (idGame: string): string => buildUrl('/games/{idGame}/themes', { idGame }),
  },
  quemSouEu: {
    /** Cria a sessão do Modo Solo. */
    startSession: (): string => quemSouEuSessions.sessions(),
    interaction: (idSession: string): string =>
      quemSouEuSessions.sessionAction(idSession, 'interaction'),
    giveUp: (idSession: string): string => quemSouEuSessions.sessionAction(idSession, 'giveup'),
    /** `date` em `yyyy-MM-dd`. */
    startDailySession: (idTheme: string, date: string): string =>
      buildUrl(`/${GamesName.QuemSouEu}/themes/{idTheme}/daily/{date}/sessions`, { idTheme, date }),
    /** Só aceita sessões do Desafio Diário em andamento. */
    getSession: (idSession: string): string => quemSouEuSessions.session(idSession),
  },
} as const;
